export default "__VITE_ASSET__CwEIrJ5___"